import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundstationcabbooking() {



  const cardData =
  {
    keyword: 'Daund Station Cab Booking',
    heading: 'Sanavi Travels: Daund Station Cab Booking',
    headingDescription: 'Sanavi Travels offers reliable Daund Station Cab Booking, providing safe, comfortable, and hassle-free taxi services for passengers arriving at or departing from Daund Railway Station. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cabs ensures clean interiors, air-conditioning, and ample luggage space for a smooth and convenient journey. With professional chauffeurs, instant booking options, transparent pricing, and 24/7 customer support, Sanavi Travels guarantees punctual pickups and drops for local travel, outstation trips, and pilgrimage journeys. We provide quick cab services from Daund Station to Shirdi, Shani Shingnapur, Pune, Baramati, Ahmednagar, and surrounding destinations. Choose Sanavi Travels for trusted Daund Railway Station cab booking services, delivering comfort, safety, and dependable travel every time.',

    top: 'Top Places to Visit in Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Located near Daund, Bhigwan Bird Sanctuary is a paradise for bird lovers and nature enthusiasts. Often called the 'Bharatpur of Maharashtra,' it attracts migratory birds like flamingos, pelicans, and storks, especially during winter. Boat safaris and sunrise views make it a must-visit destination."
  },
  {
    "title": "Ujani Dam Backwaters",
    "description": "The backwaters of Ujani Dam near Daund offer a serene landscape of vast water spread and open skies. The area is ideal for peaceful outings, photography, and birdwatching, particularly during early mornings and evenings."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "Shri Siddheshwar Temple is an important local religious site in Daund, attracting devotees throughout the year. The temple is known for its calm spiritual atmosphere and traditional rituals performed during festivals."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is one of the major railway hubs in Maharashtra, connecting important routes toward Pune, Solapur, and southern India. The historic junction plays a vital role in trade, travel, and regional connectivity."
  },
  {
    "title": "Bhigwan Wetlands",
    "description": "The wetlands around Bhigwan near Daund support rich biodiversity and seasonal migratory birds. Nature walks and boat rides allow visitors to experience untouched natural beauty and rural landscapes."
  },
  {
    "title": "Local Sugar Factories Area",
    "description": "Daund is surrounded by sugarcane fields and sugar factories that represent the agricultural backbone of the region. These areas highlight rural life and Maharashtra’s cooperative farming culture."
  },
  {
    "title": "Village Temples and Wadas",
    "description": "Traditional village temples and old wadas around Daund reflect the cultural and architectural heritage of rural Maharashtra. These sites offer insight into local traditions, festivals, and community life."
  },
  {
    "title": "Indapur Road Countryside",
    "description": "The countryside along Indapur Road near Daund offers scenic drives with open fields, canals, and sunset views. It is ideal for short nature breaks and relaxed travel experiences."
  },
  {
    "title": "Local Weekly Markets",
    "description": "Weekly markets in Daund are vibrant centers of local trade, selling fresh produce, grains, livestock, and daily essentials. They provide an authentic experience of rural Maharashtra’s lifestyle."
  },
  {
    "title": "Pilgrimage Routes Nearby",
    "description": "Daund lies on important travel routes connecting Pune, Solapur, Pandharpur, and Bhigwan. Many pilgrims use Daund as a transit point while visiting major religious destinations."
  }
]
,



"services": [
  {
    "name": "Daund Station Cab Booking",
    "description": "Daund Station Cab Booking provides reliable and convenient cab services for passengers arriving at or departing from Daund railway station. Well-maintained, air-conditioned cabs with clean interiors and comfortable seating ensure a smooth transition between the station and your destination. Experienced chauffeurs track train schedules, manage station-area traffic, and ensure timely pickups and drop-offs. Ideal for families, senior citizens, and regular travelers, this service supports local travel, outstation journeys, and flexible scheduling for stress-free railway transfers."
  },
  {
    "name": "Daund Railway Station Taxi",
    "description": "Daund Railway Station Taxi offers dependable taxi services specifically designed for railway passengers. Comfortable AC taxis with professional drivers ensure punctual pickups, safe driving, and quick station exits. Suitable for solo travelers, families, and tourists, this service focuses on convenience, reliability, and smooth station-to-destination travel."
  },
  {
    "name": "Cab Pickup Daund Station",
    "description": "Cab Pickup Daund Station ensures prompt and hassle-free cab pickups directly from the railway station. Drivers coordinate arrival times with train schedules to minimize waiting time. Clean, air-conditioned cabs provide comfortable seating and ample luggage space, making this service ideal for travelers with heavy bags or elderly passengers."
  },
  {
    "name": "AC Cab Daund Station",
    "description": "AC Cab Daund Station ensures a cool and comfortable ride for travelers immediately after train journeys. Fully air-conditioned cabs with clean interiors and smooth suspension help reduce travel fatigue. Professional chauffeurs ensure safe driving and efficient route planning, making this service suitable for both local and outstation travel from Daund."
  },
  {
    "name": "Affordable Taxi Daund",
    "description": "Affordable Taxi Daund offers budget-friendly taxi options without compromising comfort or safety. Clean, air-conditioned taxis with experienced drivers ensure smooth and economical travel from Daund station and nearby areas. Ideal for cost-conscious travelers, families, and daily commuters seeking reliable transport."
  },
  {
    "name": "Chauffeur Driven Cab Daund",
    "description": "Chauffeur Driven Cab Daund provides a stress-free travel experience with professional drivers handling navigation, traffic, and timing. Comfortable AC cabs allow passengers to relax after long train journeys. Especially suitable for elderly travelers and families, this service emphasizes safety, courtesy, and punctual service."
  },
  {
    "name": "Best Cab Service Daund",
    "description": "Best Cab Service Daund delivers high-quality cab services with well-maintained vehicles and trained chauffeurs. Fully air-conditioned cabs ensure comfort, while professional drivers ensure timely pickups and safe arrivals. Ideal for railway transfers, local travel, and outstation trips, this service focuses on reliability and customer satisfaction."
  },
  {
    "name": "Outstation Cab Daund Station",
    "description": "Outstation Cab Daund Station provides reliable long-distance cab services directly from Daund railway station to nearby cities and destinations. Well-maintained, air-conditioned vehicles with experienced chauffeurs ensure safe highway driving, comfortable seating, and timely arrivals. Suitable for business travel, pilgrimages, and family trips."
  },
  {
    "name": "Local Cab Daund",
    "description": "Local Cab Daund is ideal for short-distance travel within Daund, including homes, hotels, offices, and nearby areas. Comfortable AC cabs with knowledgeable local drivers ensure quick and convenient transportation. This service is suitable for daily commuting, errands, and local sightseeing."
  },
  {
    "name": "Tourist Cab Daund",
    "description": "Tourist Cab Daund provides organized cab services for tourists visiting Daund and nearby attractions. Comfortable air-conditioned cabs with experienced chauffeurs ensure a pleasant and informative travel experience. Perfect for families, couples, and groups planning sightseeing or onward travel."
  },
  {
    "name": "Online Cab Booking Daund",
    "description": "Online Cab Booking Daund allows customers to easily reserve cabs for station pickups, local travel, and outstation journeys through a simple booking process. Users can choose cab type, pickup time, and destination with quick confirmation. This service ensures convenience, transparency, and hassle-free travel planning."
  },
  {
    "name": "Railway Transfer Cab",
    "description": "Railway Transfer Cab offers dedicated cab services for smooth transfers to and from Daund railway station. The service focuses on punctuality, easy coordination, and comfortable vehicles to ensure a stress-free railway commute. Ideal for families, business travelers, and senior citizens."
  },
  {
    "name": "Family Cab Daund",
    "description": "Family Cab Daund is designed to make family travel safe, comfortable, and convenient. Spacious air-conditioned cabs with ample luggage space accommodate all family members easily. Professional chauffeurs ensure smooth driving and flexible schedules, making this service ideal for station pickups and outstation family trips."
  },
  {
    "name": "24x7 Taxi Daund",
    "description": "24x7 Taxi Daund provides round-the-clock taxi availability for early morning train arrivals, late-night departures, and emergency travel needs. Air-conditioned taxis with professional chauffeurs ensure safe and timely service at any hour. Suitable for passengers requiring flexible and reliable station transport."
  },
  {
    "name": "Daund Travel Taxi",
    "description": "Daund Travel Taxi offers dedicated taxi solutions for travelers arriving at or departing from Daund. Comfortable AC cabs with trained chauffeurs ensure smooth travel for railway transfers, local trips, and outstation journeys. This service emphasizes comfort, safety, flexibility, and dependable service."
  }
],
"tableData": [
  ["Daund Station Cab Booking", "Daund Railway Station Taxi"],
  ["Cab Pickup Daund Station", "AC Cab Daund Station"],
  ["Affordable Taxi Daund", "Chauffeur Driven Cab Daund"],
  ["Best Cab Service Daund", "Outstation Cab Daund Station"],
  ["Local Cab Daund", "Tourist Cab Daund"],
  ["Online Cab Booking Daund", "Railway Transfer Cab"],
  ["Family Cab Daund", "24x7 Taxi Daund"],
  ["Daund Travel Taxi", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Daund Station Cab Booking with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and convenient cab booking services from Daund Railway Station, ideal for local travel, outstation trips, pilgrimages, and business journeys."
  },
  {
    "WhyChooseheading": "Quick Pickup from Daund Railway Station",
    "WhyChoosedescription": "Our cabs are available for prompt pickup directly from Daund Station, ensuring a hassle-free start to your journey."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Cabs",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs for a smooth and relaxing ride from Daund Station."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with Daund city and outstation routes, ensuring safe travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Daund Station cab bookings, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Cab Booking Service",
    "WhyChoosedescription": "Book a cab from Daund Station anytime, day or night, with our round-the-clock booking and customer support."
  },
  {
    "WhyChooseheading": "Flexible Cab Options",
    "WhyChoosedescription": "Choose from sedans, SUVs, and premium cars for local, one-way, or round-trip travel from Daund Station."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab booking from Daund Railway Station?',
    answer: 'Yes, Sanavi Travels offers reliable cab booking services directly from Daund Railway Station.'
  },
  {
    question: 'How can I book a cab from Daund Station?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Are cabs available for late-night or early-morning train arrivals?',
    answer: 'Yes, our Daund Station cab service is available 24x7 for all train arrival and departure timings.'
  },
  {
    question: 'What types of cabs are available from Daund Station?',
    answer: 'We provide sedans, SUVs, and premium cars for local and outstation travel.'
  },
  {
    question: 'Are drivers familiar with local and outstation routes?',
    answer: 'Yes, our drivers are professional, licensed, and experienced with Daund and nearby routes.'
  },
  {
    question: 'Can I book a cab from Daund Station to Shirdi or Pune?',
    answer: 'Absolutely. We offer outstation cab services from Daund Station to Shirdi, Pune, and other destinations.'
  },
  {
    question: 'Are vehicles sanitized before pickup?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before every pickup.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prakash Jadhav',
    feedback: 'Booked a cab from Daund Station. On-time pickup, clean car, and very professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Aarti Kulkarni',
    feedback: 'Excellent Daund Station cab service. Smooth booking process and great customer support.',
    rating: 5
  }
];













































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund Station Cab Booking - Sanavi Travels",
  "description": "Book AC and chauffeur-driven cabs at Daund Railway Station with Sanavi Travels. Ideal for railway pickups, local travel, outstation trips, family trips, tourist travel, and 24x7 cab service from Daund Station.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Daund Station Cab Booking | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and chauffeur-driven cabs at Daund Railway Station with Sanavi Travels. Perfect for railway pickups, local and outstation travel, family trips, tourist travel, and 24x7 cab service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/90.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundstationcabbooking;